import { code } from "@spscommerce/utils";

export const SpsProductBarExamples = {
    basic: {
        label: "Product Bar",
        description: code`
            <p>Product navigation bar</p>
        `,
        examples: {
            basic: {
                template: code`
                    <!-- position: relative is to display this example in its place instead of at the top -->
                    <sps-product-bar productName="My Product"
                        productLogoSrc="https://cdn.prod.spsc.io/web/framework/assets/17.08.01/icons/cube/cube.svg"
                        style="position: relative"
                    ><sps-button>do the thing</sps-button></sps-product-bar>
                `
            },
        }
    }
};
